var map = {
	"./atlas.svg": 8502,
	"./digital.svg": 4452,
	"./jn.svg": 7304,
	"./m1.svg": 5460,
	"./mgu.svg": 9068,
	"./parimatch.svg": 6316,
	"./playboy.svg": 2948,
	"./sluhay.svg": 389,
	"./sw.svg": 7919,
	"./tk.svg": 1223,
	"./twn.svg": 942,
	"./unn.svg": 4766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7392;